export const REGISTRATION_PRIMARY = "#aece38";
export const REGISTRATION_PRIMARY_DARK = "#8aab15";
export const REGISTRATION_LINK = "#3f5c0e";
/** Keyboard focus ring — same color on fields and buttons */
export const REGISTRATION_FOCUS_RING = REGISTRATION_LINK;
export const REGISTRATION_FOCUS_GLOW = "rgba(63, 92, 14, 0.18)";
export const REGISTRATION_HOVER_FILL = "rgba(63, 92, 14, 0.08)";
export const REGISTRATION_HOVER_FILL_STRONG = "rgba(63, 92, 14, 0.12)";
export const REGISTRATION_AMBER = "#f0af42";
export const REGISTRATION_FOREST = "#5a6b80";
export const REGISTRATION_NAVY = "#2d3f52";
export const REGISTRATION_ON_PRIMARY = "#1e2a35";
export const REGISTRATION_ERROR = "#b8481a";
export const REGISTRATION_PLACEHOLDER = "#5a6b80";
export const REGISTRATION_FONT_BODY = "'Poppins', sans-serif";
export const REGISTRATION_FONT_DISPLAY = "'Playfair Display', serif";
